var impressum = "ข้อมูลลิขสิทธิ์";
var privacy = "ความเป็นส่วนตัวและกฎหมาย";
var recallInfo = "ข้อมูลการเรียกคืน";
var signOut = "ลงชื่อออก";
var th_th = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { th_th as default, impressum, privacy, recallInfo, signOut };
